module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/kh-695ec7a1a39090e600d533a38c5db55c.svg";